module.exports = __webpack_public_path__ + "static/media/ic_default_avatar.7de5e5f7.svg";